import { Box, Button } from "@mui/material";
import config from "../config";

const GoogleLoginButton = () => {
  const CLIENT_ID = config.googleClientId;
  const BASE_URL = window.location.origin;
  const REDIRECT_URI = `${BASE_URL}/google-authorization/`;

  const STATE = crypto.randomUUID();

  const handleGoogleLogin = () => {
    const googleAuthUrl =
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `scope=email%20profile&` +
      `response_type=code&` +
      `client_id=${CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
      `state=${STATE}`;

    window.location.href = googleAuthUrl;
  };

  return (
    <Button
      variant="contained"
      onClick={handleGoogleLogin}
      startIcon={
        <Box
          component="img"
          src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 48 48'%3E%3Cdefs%3E%3Cpath id='a' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/defs%3E%3CclipPath id='b'%3E%3Cuse xlink:href='%23a' overflow='visible'/%3E%3C/clipPath%3E%3Cpath clip-path='url(%23b)' fill='%23FBBC05' d='M0 37V11l17 13z'/%3E%3Cpath clip-path='url(%23b)' fill='%23EA4335' d='M0 11l17 13 7-6.1L48 14V0H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%2334A853' d='M0 37l30-23 7.9 1L48 0v48H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%234285F4' d='M48 48L17 24l-4-3 35-10z'/%3E%3C/svg%3E"
          alt="Google logo"
          sx={{
            width: 20,
            height: 20,
          }}
        />
      }
      sx={{
        backgroundColor: "#1a1a2c",
        border: "1px solid #ddd",
        textTransform: "none",
        width: "100%",
        color: "#fff",
        fontWeight: 500,
        fontSize: "15px",
        borderRadius: 0,
        padding: "12px 20px",
        justifyContent: "flex-start",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        "& .MuiButton-startIcon": {
          marginRight: "12px",
          marginLeft: 0,
        },
        "&:hover": {
          backgroundColor: "#1a1a2c",
        },
      }}
    >
      Continue with Google
    </Button>
  );
};

export default GoogleLoginButton;
